import request from '@/utils/request'

// 提现记录分页查询
export const withdrawPage = (params) => {
  return request({
    url: '/withdraw/log/page',
    method: 'get',
    params
  })
}

// 获取提现设置
export const getWithdrawRate = () => {
  return request({ 
    url: '/withdraw/log/rate', 
    method: 'get' 
  })
}

// 保存提现设置
export const setWithdrawRate = (data) => {
  return request({
    url: '/withdraw/log/rate',
    method: 'post',
    data  // 传递JSON数据体
  })
}

// 提现审核
export const withdrawAuditApi = (id, status, reason) => {
  return request({
    url: `/withdraw/log/audit/${id}/${status}`,
    method: 'post',
    params: { reason: reason || '' }  // 传递拒绝原因参数
  })
}

// 首页统计
export const getIndexStatistics = (params) => {
  return request({
    url: '/index/statistics',
    method: 'get',
    params
  })
}

// 发帖内容统计 
export const getBoardContentStatistics = (params) => {
  return request({
    url: '/index/contentStatistics',
    method: 'get',
    params
  })
}

// 用户注册统计
export const getUserStatistics = (params) => {
  return request({
    url: '/index/userStatistics',
    method: 'get',
    params
  })
}

// 查询用户邀请记录
export const getUserInvitationPage = (params) => {
  return request({
    url: '/user/invitation/page',
    method: 'get',
    params
  })
}

// 礼物记录分页
export const getGiftRecordPage = (params) => {
  return request({
    url: '/user/gift/record/page',
    method: 'get',
    params
  })
}

// 分页查询用户余额记录
export const getBalanceRecordPage = (params) => {
  return request({
    url: '/balance/record',
    method: 'get',
    params
  })
}

// 手动充值钻石
export const manualRecharge = (data) => {
  return request({
    url: '/admin/recharge/manual',
    method: 'post',
    data
  })
}

// 获取积分分页
export const getPointsRecordPage = (params) => {
  return request({
    url: '/admin/recharge/pointsPage',
    method: 'get',
    params
  })
}

// 手动充值积分
export const manualPointsRecharge = (data) => {
  return request({
    url: '/admin/recharge/manualPoints',
    method: 'post',
    data
  })
}
